import { configureStore } from "@reduxjs/toolkit";
import mediaTypeSlice from "../Slices/mediaTypeSlice";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import { apiSlice } from "../Slices/apiSlice";
import movieGenreSlice from "../Slices/movieGenreSlice";
import seriesGenreSlice from "../Slices/seriesGenreSlice";
import reviewModalSlice from "../Slices/reviewModalSlice";
import authModalSlice from "../Slices/authModalSlice";
import userSlice from "../Slices/userSlice";
import viewReviewModalSlice from "../Slices/viewReviewModalSlice";
import postModalSlice from "../Slices/postModalSlice";
import postTitlesSlice from "../Slices/postTitlesSlice";
import searchModalSlice from "../Slices/searchModalSlice";
import watchlistModalSlice from "../Slices/watchlistModalSlice";
import userRatingsModalSlice from "../Slices/userRatingsModalSlice";
import profileModalSlice from "../Slices/profileModalSlice";
import drawerSlice from "../Slices/drawerSlice";
import freeToWatchSlice from "../Slices/freeToWatchSlice";
import watchProvidersModalSlice from "../Slices/watchProvidersModalSlice";

const rootReducer = combineReducers({
  // here add reducers which we want to persist...
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: {
    // persisted: persistedReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
    mediaTypeSlice: mediaTypeSlice.reducer,
    movieGenreSlice: movieGenreSlice.reducer,
    seriesGenreSlice: seriesGenreSlice.reducer,
    reviewModalSlice: reviewModalSlice.reducer,
    authModalSlice: authModalSlice.reducer,
    userSlice: userSlice.reducer,
    viewReviewModalSlice: viewReviewModalSlice.reducer,
    postModalSlice: postModalSlice.reducer,
    postTitlesSlice: postTitlesSlice.reducer,
    searchModalSlice: searchModalSlice.reducer,
    watchlistModalSlice: watchlistModalSlice.reducer,
    userRatingsModalSlice: userRatingsModalSlice.reducer,
    profileModalSlice: profileModalSlice.reducer,
    drawerSlice: drawerSlice.reducer,
    freeToWatchSlice: freeToWatchSlice.reducer,
    watchProvidersModalSlice: watchProvidersModalSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;
export const persistor = persistStore(store);

export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
